import React, { memo } from "react";
import BaseButton from "../BaseButton";
import PropTypes from "prop-types";
import BaseIcon from "../BaseIcon";
import "./style.scss";

function BaseTextButton({
  children,
  onClick,
  className,
  to,
  icon,
  iconStyle,
  iconWrapperStyle,
  target,
  native,
  href,
  iconPlace = "left",
}) {
  BaseTextButton.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    className: PropTypes.string,
    to: PropTypes.string,
    icon: PropTypes.string,
    iconStyle: PropTypes.string,
    iconWrapperStyle: PropTypes.string,
    target: PropTypes.string,
    native: PropTypes.bool,
    href: PropTypes.string,
    iconPlace: PropTypes.string,
  };
  const cls = ["text-button"];
  const iconCls = ["with-icon__icon"];
  const iconWrapperCls = ["text-button__icon-wrapper"];
  if (className) cls.push(className);
  if (icon) cls.push("with-icon");
  if (iconPlace === "left") cls.push("with-icon__left");
  if (iconPlace === "right") cls.push("with-icon__right");
  if (iconStyle) iconCls.push(iconStyle);
  if (iconWrapperStyle) iconWrapperCls.push(iconWrapperStyle);
  return (
    <BaseButton
      native={native}
      target={target}
      type="text"
      to={to}
      onClick={onClick}
      className={cls.join(" ")}
      href={href}
    >
      {iconPlace === "left" ? (
        <div className={iconWrapperCls.join(" ")}>
          {icon && <BaseIcon name={icon} className={iconCls.join(" ")} />}
        </div>
      ) : null}
      <span className="text-button__label">{children}</span>
      {iconPlace === "right" ? (
        <div className={iconWrapperCls.join(" ")}>
          {icon && <BaseIcon name={icon} className={iconCls.join(" ")} />}
        </div>
      ) : null}
    </BaseButton>
  );
}

export default memo(BaseTextButton);
